module.exports = __webpack_public_path__ + "img/logo.036f1b21.png";